import * as React from 'react';
import Funding from '@company/components/Funding/Funding';
import Details from '@company/components/Details/Details';
import WhitepaperComponent from '@company/components/WhitepaperComponent/WhitepaperComponent';
import CoverImageComponent from '@company/components/CoverImageComponent/CoverImageComponent';
import Documents from '@company/components/Documents/Documents';
import InvestorsPeople from '@company/components/Investors/Investors';
import TopInvestorsPeople from '@company/components/TopInvestors/TopInvestors';
import MembersPeople from '@company/components/Members/Members';
import Loader from '@appComponents/Loader/Loader';
import TradingDetails from '@company/components/TradingDetails/TradingDetails';
import { IOverviewPageProps } from './IOverviewPageProps';
import { Link } from 'react-router-dom';

import * as app from '../../AppStyle.module.scss';

class OverviewPage extends React.Component<IOverviewPageProps> {
  render() {
    const { companyId } = this.props.match.params;
    const { companyDetails, userSignedIn, isCreator, isOwner, isUsInvestor, isUnverified } = this.props;
    const { editMode } = this.props;
    const sectionClass = editMode ?
      [app.companyMain, app.companyMainEdit, 'appCompany'].join(' ') :
      [app.companyMain, 'profiles'].join(' ');

    return (
      <div>
        {
          !editMode && !isCreator && companyDetails.profile_id === null &&
          <div className={app.containerInfo} data-cy="company-info">
            <p>This company is added and managed by our Community. Some information may not be correct.</p>
          </div>
        }
        {(!editMode && isUnverified || !editMode && isOwner && companyDetails.labels.includes('hidden')) &&
          <div className={[app.containerInfo, app.containerInfoOrange].join(' ')} data-cy="company-info">
            <p>
              <i className={[app.fa, 'fa', 'fa-exclamation-circle'].join(' ')}/>
              Your company is not yet listed in our directory.
              <Link
                className={app.containerInfoLink}
                to={`/companies/${companyDetails.slug}/verification`}
                onClick={this.props.setEditMode}
                data-cy="company-info-verify"
              >
                Please verify it first.
              </Link>
            </p>
          </div>
        }
        <CoverImageComponent
          editMode={editMode}
          isSaving={this.props.isSaving}
        />

        <div className={editMode ? app.companyContainerEdit : app.companyContainer}>
          <main className={sectionClass}>
            <Details
              editMode={editMode}
              isSaving={this.props.isSaving}
              isOwner={isOwner}
              isCreator={isCreator}
            />

            <Funding isSaving={this.props.isSaving} editMode={editMode}/>

            <TopInvestorsPeople
              editMode={editMode}
              companyID={companyId}
            />

            <InvestorsPeople
              editMode={editMode}
              companyID={companyId}
              isSaving={this.props.isSaving}
            />

            <MembersPeople
              editMode={editMode}
              companyID={companyId}
              isSaving={this.props.isSaving}
            />
          </main>
          <aside className={editMode ? [app.sidebar, app.sidebarEdit].join(' ') : app.sidebar}>
            {!editMode && <TradingDetails userSignedIn={userSignedIn} />}
            {!editMode && <WhitepaperComponent isUsInvestor={isUsInvestor} userSignedIn={userSignedIn} />}
            <Documents
              isSaving={this.props.isSaving}
              editMode={editMode}
              isOwner={this.props.isOwner}
            />
          </aside>
        </div>
      </div>
    ) || <Loader />;
  }
}

export default OverviewPage;
